<template>
  <div class="mission-ranking-share-post-section" @click="() => {}">
    <div class="mission-ranking-share-post-section__modal">
      <div class="mission-ranking-share-post-section__modal-inner">
        <div class="mission-ranking-share-post-section__header">
          <p class="mission-ranking-share-post-section__title">
            {{ $tc('MissionPage.RankingPage.Share.postOnlyX') }}
          </p>
        </div>
        <div class="mission-ranking-share-post-section__thumbnail" ref="thumbnail">
          <img
            class="mission-ranking-share-post-section__thumbnail-image"
            :src="imageUrl"
            :style="{ height: `${imageHeight - 12}px` }"
            alt="Ranking Image"
          />
        </div>
        <div class="mission-ranking-share-post-section__input">
          <mission-ranking-share-input-section
            @onToggleEnabledInput="$emit('onClickCancel')"
            @onClickPostSns="onClickPostSns"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onBeforeMount, onMounted, ref } from '@vue/composition-api'
import MissionRankingShareInputSection from '@/components/MissionPage/MissionRankingPane/MissionRankingShareInputSection.vue'

export default defineComponent({
  name: 'MissionRankingSharePostSection',
  components: { MissionRankingShareInputSection },
  props: {
    imageUrl: {
      type: String,
      required: true,
    },
  },
  setup() {
    const thumbnail = ref<HTMLImageElement | null>(null)
    const imageHeight = ref(252)

    const setImageHeight = () => {
      imageHeight.value = thumbnail.value?.getBoundingClientRect().height || 252
    }

    onMounted(() => {
      setImageHeight()

      window.addEventListener('resize', setImageHeight)
    })

    onBeforeMount(() => {
      window.removeEventListener('resize', setImageHeight)
    })

    return {
      thumbnail,
      imageHeight,
    }
  },
  methods: {
    onClickPostSns(comment: string, postX: boolean, postInstagram: boolean) {
      this.$emit('onClickPostSns', this.imageUrl, comment, postX, postInstagram)
    },
  },
})
</script>

<style scoped lang="scss">
.mission-ranking-share-post-section {
  width: 100%;
  height: 100%;
  background-color: $black70;

  &__modal {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    padding: 6px 6px 0;

    &-inner {
      display: flex;
      flex-direction: column;
      width: 100%;
      max-height: 100svh;
      background-color: #2b2b2b;
    }
  }

  &__header {
    display: flex;
    flex-shrink: 0;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 44px;
    border-bottom: 1px solid rgba(#fff, 0.1);
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
  }

  &__title {
    font-size: 14px;
    font-weight: 700;
    color: $white;
    letter-spacing: 0.02em;
  }

  &__thumbnail {
    flex-basis: 252px;
    padding-top: 8px;
    padding-bottom: 4px;
    overflow: hidden;

    &-image {
      display: block;
      height: 100%;
      max-height: 252px;
      margin: auto;
      aspect-ratio: 1;
    }
  }

  &__input {
    flex-shrink: 0;
    padding-right: 10px;
    padding-left: 10px;
  }
}
</style>
